/* ======================================================================== */
/* 24. sectionIntro */
/* ======================================================================== */
var SectionIntro = function ($scope) {

	var
		$target = $scope.find('.section-intro[data-os-animation]'),
		$wrapper = $target.closest('.elementor-section'),
		tl = new TimelineMax(),
		$heading = $target.find('h1'),
		$subheading = $target.find('.section-intro__subheading'),
		$highlightWrapper = $heading.find('.highlight'),
		$highlight = $heading.find('.highlight__bg'),
		$button = $target.find('.section-intro__wrapper-button'),
		$headline = $target.find('.section-intro__line'),
		splitHeading = splitLines($heading),
		splitSubheading = splitLines($subheading),
		wrapperProperties = $wrapper.css([
			'background-color',
			'background-image'
		]);

	prepare();
	animate();

	function prepare() {

		if (!$target.length) {
			return;
		}

		setLines(splitHeading.words);
		setLines(splitSubheading.words);

		if (wrapperHasBackground()) {
			TweenMax.set($wrapper, {
				scaleY: 0,
				transformOrigin: 'bottom center'
			});
		}

		TweenMax.set($highlight, {
			x: '-100%',
			y: '98%'
		});

		TweenMax.set($button, {
			autoAlpha: 0,
			y: '30px'
		});

	}

	function animate() {

		if (!$target.length) {
			return;
		}

		var $trigger = $target;

		tl
			.set($wrapper, {
				autoAlpha: 1,
			})
			.to($wrapper, wrapperHasBackground() ? 0.6 : 0, {
				scaleY: 1,
				ease: Expo.easeInOut,
			})
			.add(animateLines(splitHeading.words, 0.6, 0.03))
			.to($button, 0.6, {
				autoAlpha: 1,
				y: '0px'
			}, '-=0.3')
			.add(animateLines(splitSubheading.words, 0.6, 0.03), '-=0.3')
			.staggerTo($highlight, 0.6, {
				x: '0%',
				ease: Expo.easeInOut
			}, 0.15, '-=0.6')
			.staggerTo([$highlightWrapper, $highlight], 0.6, {
				y: '0%',
				color: '#ffffff',
				ease: Expo.easeInOut
			}, 0.15, '-=0.3');

		if ($target.data('os-animation') == 'force') {
			$trigger = $('body');
		}

		if (wrapperHasBackground()) {
			tl.to($wrapper, 0.6, {
				scaleY: 1,
				ease: Expo.easeInOut,
			}, '0');
		}

		createOSScene($target, tl, $trigger);

	}

	function wrapperHasBackground() {

		return wrapperProperties['background-color'] !== 'rgba(0, 0, 0, 0)' && wrapperProperties['background-color'] !== 'rgb(0, 0, 0)' && wrapperProperties['background-image'] == 'none';

	}

}
